import { DownOutlined, RetweetOutlined } from '@ant-design/icons';
import { Cancel, CheckOutlined, Print } from '@mui/icons-material';
import { Alert, Snackbar } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as Sentry from '@sentry/react';
import { Button as AntdButton, Select as AntSelect, Dropdown, Skeleton, Space, Tag, Tooltip } from "antd";
import SuperLessonEditor from "components/ebook/Superlession/LessionEditor";
import Loading from "components/Loading";
import { useMobileDetect, useTabletDetection } from "containers/chat/hooks";
import { filter, find, get, map } from "lodash";
import React, { Suspense, useCallback, useEffect, useMemo, useRef, useState } from "react";

const Lottie = React.lazy(() => import('lottie-react'));
import { useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { useSuperLesson } from "store/SuperLesson/selectors";
import { useAllDistrictTeacher, useCurrentUser, useUserProfileConfig } from "store/users/selectors";
import styledComponents, { keyframes } from "styled-components";
import styled from "styled-components";
import { ELEPHANT } from "utils/assets/images/lootie";
import color from "utils/constants/color";
import { addPrintableClass, cleanHTMLString, converMarkToHtmlText, removePrintableClass } from "utils/methods/textMethod";
import SuperLessonLogo from "../../utils/assets/images/super-lesson-logo.svg";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import {
  handleCreateSuperLesson,
  handleDeleteSuperLesson,
} from "store/SuperLesson/thunks";
import { getAwsAuthToken } from 'utils/lib/authHelper';
import sysConf from "config";
import AIUsageInfo from 'components/Modals/AiInfoModal';
import COLOR from "utils/constants/color";
import moment from 'moment-timezone';


const LessonContainer = styledComponents.section`
  padding-top: 15px;
  padding-left: 27px;
  padding-right: 33px;
  padding-bottom: 20px;
  background: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 50;
  @media (max-width: 700px) {
    display: ${p => p.isCanvasUser ? 'unset' : 'none'};
  }
`;

const LessonModal = styledComponents.div`
  background: #000f4c;
  border-radius: 11px;
  padding-left: ${(p) => (p.view ? "51px" : "19px")};
  padding-right: ${(p) => (p.view ? "51px" : "19px")};
  padding-bottom: ${(p) => (p.view ? "34px" : "26px")};
  padding-top: ${(p) => (p.view ? "51px" : "19px")};
  height: ${(p) => (p.view ? "unset" : "100%")};
  // overflow: hidden auto;
`;

const Container = styledComponents.div`
  display: flex;
  align-items: center;
  width: 100%;
  // max-height: 150px;
  flex-direction: row;
  overflow:auto;
`;

const SuperLessonLogoImg = styledComponents.img`
  @media (max-width: 768px) {
    width: 57px;
    height: 51px;
  }
`;

const ViewContainer = styledComponents.div`
  margin-left: 13px;
  display: flex;
  flex-wrap: wrap;
  /* gap: 10px; */
  column-gap: 6px;
  row-gap: 12px;

  @media (max-width: 600px){
    row-gap: ${p=> p.isCanvasUser && "2px" };
  }

  @media (max-width: 425px){
    margin-left: ${p=> p.isCanvasUser && "5px" };
    row-gap: ${p=> p.isCanvasUser && "2px" };
  }
`;

const BoxContainer = styledComponents.div`
  display: flex;

  align-items: center;
  gap: 12px;
`;
const NoMessageContainer = styledComponents.div`
  display:flex;
  align-items:center;
  justify-content:center;
  flex-direction:column;
`;

const Label = styledComponents.label`
  color: #fff;
  // font-family: "Gotham";
  font-size: 15px;
  font-style: italic;
  font-weight: 400;
  // font-family: Gotham;
  white-space: nowrap;

  @media (max-width: 768px) {
    color: #fff;
    font-size: 13px;
    font-style: italic;
    font-weight: 400;
  }
`;

const FieldBox = styledComponents.div`
  display: grid;
  place-items: center;
  border-radius: 9.5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  text-align: center;
  min-width: 63px;

  // width: 108px;
  height: 19px;
  color: #000;
  // font-family: Gotham;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  flex: 1;
  max-width: 241px;

  @media (max-width: 768px) {
    color: #000;
    // font-family: "Gotham";
    font-size: 10px;
    font-style: italic;
    font-weight: 400;
  }
`;

const FieldShareBox = styledComponents.div`
  display: grid;
  place-items: center;
  border-radius: 9.5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  text-align: center;
  min-width: 63px;

  // width: 108px;
  height: 31px;
  color: #000;
  // font-family: Gotham;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  flex: 1;
  max-width: 241px;

  @media (max-width: 768px) {
    color: #000;
    // font-family: "Gotham";
    font-size: 10px;
    font-style: italic;
    font-weight: 400;
  }
`;

const FieldBoxState = styledComponents.div`
  display: grid;
  place-items: center;
  border-radius: 9.5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  text-align: center;
  min-width: 85px;

  // width: 108px;
  height: 19px;
  color: #000;
  // font-family: Gotham;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  flex: 1;
  max-width: 241px;

  @media (max-width: 768px) {
    color: #000;
    // font-family: "Gotham";
    font-size: 10px;
    font-style: italic;
    font-weight: 400;
  }
`;

const WhiteBox = styledComponents.div`
  height: calc(100% - 185px);
  padding: 10px;
  border-radius: 10px;
  border: 2px solid #e8e8e8;
  background: #fff;
  width: 100%;
  // height: 100%;
  // max-height: 700px;

  margin-top: 24px;
  overflow-x: hidden;
  background-color: #fff;
  overflow-y: auto;

  @media (max-width: 1367px) {
    height: calc(100% - 195px);
  }

  @media (max-width: 768px) {
    height: calc(100% - 188px);
  }
  @media print {
    overflow: visible;
    all: unset; /* <-- reset all styles */
    display: block;
    width: 100%;
    height: auto;
    page-break-inside: avoid;
    break-inside: avoid;
    padding: 0;
    margin: 0;
    border: none;
    background: none;
    @page {
      margin-top: 20px;
      margin-bottom: 20px;
      margin-left: 25px;
      margin-right: 25px;
   }
  }
`;
const pulse = keyframes`
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7); }
  70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(76, 175, 80, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(76, 175, 80, 0); }
`;

const RetryButton = styledComponents.button`
  background-color: #4caf50;
  color: white;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 24px;
  border: none;
  border-radius: 30px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
  animation: ${pulse} 2s infinite;

  &:hover {
    background-color: #43a047;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.97);
  }
`;

const useStyles = makeStyles({
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "transparent !important",
    },
    menuItemText: {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      maxWidth: "150px",
      display: "block",
    },
    disabledButton: {
      color: "white",
      "&.Mui-disabled": {
        color: "white !important",
      },
    },
  },
});

const LessonViewModal = ({
  open,
  onClose,
  showModal,
  viewLessonType,
  superLessonData,
  data,
  from,
  isCanvasUser,
  pageId,
  bookId,
  viewLessonTypeValue,
  setViewLessonTypeValue,
  newMaskId = '',
  superLessonConfig = {}
}) => {
  const showAlert = useAlert();
  const imageRef = useRef();
  const classes = useStyles();
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const superLesson = useSuperLesson();
  const allDistrictTeacher = useAllDistrictTeacher();
  const [loader, setLoader] = useState(false);
  const [showShareList, setShowShareList] = useState(true);
  const [printLoader, setPrintloader] = useState(false)
  const [loaderRetry, setLoaderRetry] = useState(false)
  const filterLesson =
    find(
      superLesson,
      (data) =>
        data?.userId === currentUser?.id &&
        data?.access_by?.includes(currentUser?.id)
    ) || {};
  const filterShareLesson =
    filter(
      superLesson,
      (data) =>
        data?.userId !== currentUser?.id &&
        data?.access_by?.includes(currentUser?.id)
    ) || [];
  const [filterMyData, setFilterMyData] = useState(filterLesson);
  const [filterSharedLesson, setFilterSharedLesson] =
    useState(filterShareLesson);
  const [selectedTeacherIds, setSelectedTeacherIds] = useState([]);
  const [initialValues, setInitialValues] = useState([]);
  const [superData, setSuperData] = useState(filterMyData?.super_data ?? {});
  const [content, setContent] = useState('')
  const { isAiPermissionEnabled } = useUserProfileConfig();

  const standardText = superData?.standard || "";
  const stateText = superData?.state || "";
  const maxChars = 27;
  const filterByTeacher = allDistrictTeacher.find((item) =>
    filterMyData.userId === item.id
  );
  const isTablate = useTabletDetection();
  const isMobile = useMobileDetect() && !isTablate;
  const [generatedContent,setGeneratedContent] = useState('');
  const [isDropdownOpenLanguage, setIsDropdownOpenLanguage] = useState(false);
  const [languageChanger,setLanguageChanger] = useState(superData?.language);

  const getAllOptions = useMemo(() => {
    return allDistrictTeacher.map((item) => ({
      label: `${item.firstName} ${item.lastName},`,
      value: `${item?.id}`,
    }));
  }, [allDistrictTeacher]);

  async function streamData(inputData, onChunk) {
    try {
      const token = await getAwsAuthToken();
      const localUrl = `http://localhost:4000/SuperLessonStream/super-lesson-stream`;
      const prodUrl = `${sysConf.apiGateway.AI_BASE_NODE_URL}/SuperLessonStream/super-lesson-stream`;
      const response = await fetch(
        prodUrl,
        {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            "x-auth-source": sysConf.isDev ? "test" : "prod",
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(inputData),
        },
      );

      if (!response.ok || !response.body) {
        throw new Error('Stream failed to start');
      }
      

      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let buffer = '';
      let fullTextAccumulator = '';
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const text = decoder.decode(value);
        const lines = text.split('\n').filter(Boolean);

        for (const line of lines) {
          const payload = line.replace(/^data:\s*/, '').trim();
          if (line.startsWith('data:')) {
            try {
              const parsed = JSON.parse(payload);
              if (parsed?.type === 'error') {
                const blockedMessage =
                  parsed.code === 'INAPPROPRIATE_CONTENT'
                    ? parsed.message || 'Lo siento, pero no te puedo ayudar con eso'
                    : parsed.message || 'Failed to create lesson. Please try again.';
                    showAlert(blockedMessage, 'error');
                    setLoaderRetry(false);
                    setLoader(false);
                return;
              }
            } catch {
              // not a JSON payload
            }
          }
          if (line.startsWith('data:') && payload === '[DONE]') {
            setLoaderRetry(false);
            setContent(generatedContent);
            setGeneratedContent('');
            setAlertSakeBar({ open: true, message: 'Created Successfully', severity: 'success' });
            return;
          }
          if (payload && payload !== '[DONE]' && payload !== '[ERROR]' && !payload.startsWith('{')) {
            fullTextAccumulator += payload;
            onChunk(cleanHTMLString(fullTextAccumulator));
          }
        }
      }
    } catch (error) {
      console.error('Stream error:', error);
      setAlertSakeBar({
        open: true,
        message: 'Failed to create lesson. Please try again.',
        severity: 'error',
      });
    }
  }

  useEffect(() => {
    const cont = filterMyData?.lesson_content || "";
    const super_data = filterMyData?.super_data || {};
    setSuperData(super_data);
    setViewLessonTypeValue('');
    if(languageChanger === "english"){
      setContent(filterMyData?.english_content);
      setLanguageChanger("english");
      return;
    }
    setLanguageChanger(filterMyData?.language);
    setContent(cont)
  }, [filterMyData]);

  const [alertSakeBar, setAlertSakeBar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const onLessonAi = async () => {
    if (!isAiPermissionEnabled) {
      showAlert('Please enable AI permission to generate content using AI.', 'error');
      return;
    }
    const { limit, ...superLessonPayload } = filterMyData;
    const data = {
      ...superLessonPayload,
      bookId,
      pageId,
      from_page: superLessonData.from,
      to_page: superLessonData.to,
      userId: currentUser.id,
      superData,
      access_by: [currentUser.id],
      mode: import.meta.env.VITE_APP_STAGE?.trim() === "prod" ? "prod" : "dev",
    };
    setLoaderRetry(true);
    const SuperLessonData = {};
    let fullHTML = "";
  
    await streamData(data, async (chunk) => {
      fullHTML += chunk;
        setLoaderRetry(false);
        setGeneratedContent(chunk);
    });
  };
  const sharedProps = {
    mode: "multiple",
    style: {
      width: "100%",
    },
    placeholder: "Select Item...",
    maxTagCount: "responsive",
    showSearch: true,
    optionFilterProp: "label",
    filterOption: (input, option) => {
      const label = (option?.label || option?.children || '').toString().trim().toLowerCase();
      const searchText = input.trim().toLowerCase();
      if (!searchText) return true;
      const searchWords = searchText.split(/\s+/).filter(word => word.length > 0);
      return searchWords.every(word => label.includes(word));
    },
  };
  const [value, setValue] = useState([]);
  const selectProps = {
    value,
    onChange: (selectedIds) => {
      const newSelections = selectedIds.filter(item => !initialValues.includes(item.value));

      // Combine the new selections with the initial values
      const updatedSelection = [
        ...value.filter(item => initialValues.includes(item.value)),
        ...newSelections
      ];

      setValue(updatedSelection);
    },
    labelInValue: true,
  };

  useEffect(() => {
    if (viewLessonType === 'shared') {
      setShowShareList(true);
    }
  }, [superLesson])

  useEffect(() => {
    setFilterSharedLesson(filterShareLesson);
    setFilterMyData(filterLesson);
    setSelectedTeacherIds(filterLesson?.access_by || []);
    const initialAccessBy = filterLesson?.access_by?.filter(element => element !== filterLesson?.userId) || [];
    setInitialValues(initialAccessBy);
    setValue(
      (filterLesson?.access_by?.filter(element => element !== filterLesson?.userId) || [])
        .map(item => ({ value: item }))
    );
  }, [superLesson]);


  const prevShowModalRef = useRef(showModal);
  useEffect(() => {
    if (prevShowModalRef.current && !showModal) {
      onClose();
    }
    prevShowModalRef.current = showModal;
  }, [showModal]);

  const handleSharableChange = (event) => {
    setSelectedTeacherIds(event.target.value);
  };

  const isDisable=()=>{
    const selectedTeacher = value?.map((element) => element?.value)
      const combinedArray = [...selectedTeacher];
      combinedArray.push(filterLesson?.userId);
      const shareableArr = filter(combinedArray, (val) => val !== currentUser?.id)
      return shareableArr.length==0 ? false : true;
  }

  const handleShare = async () => {
    try {
      const selectedTeacher = value?.map((element) => element?.value)
      const combinedArray = [...selectedTeacher];
      combinedArray.push(filterLesson?.userId);
      const shareableArr = filter(combinedArray, (val) => val !== currentUser?.id)
      if (shareableArr?.length === 0) return;
      const data = {
        ...filterMyData,
        access_by: combinedArray,
        shared_time: moment().toISOString()
      };
      setLoader(true);
      await dispatch(handleCreateSuperLesson(data));
    } catch (error) {
      console.log(error);
      Sentry.captureException(`388 Error during handleShare: ${error}`);
    }
    finally {
      setLoader(false);
    }
  };

  const handleBack = () => {
    setShowShareList(true);
    setFilterSharedLesson(filterShareLesson);
    setFilterMyData(filterLesson);
    onClose();
  };

  const handleShareDelete = async () => {
    const data = {
      ...filterMyData,
      access_by: filter(
        filterMyData?.access_by,
        (access) => access !== currentUser?.id
      ),
    };
    if (data?.access_by?.length === 0) {
      setLoader(true);
      await dispatch(handleDeleteSuperLesson(data?.id));
      setLoader(false);
    } else {
      setLoader(true);
      await dispatch(handleCreateSuperLesson(data));
      setLoader(false);
    }
    setSelectedTeacherIds([]);
    setValue([]);
    setShowShareList(true);
    setFilterSharedLesson(filterShareLesson);
    setFilterMyData(filterLesson);
    onClose();
  };

  const renderSelectedValues = (selected) => {
    const removeCurrentId = filter(
      selected,
      (select) => select !== currentUser?.id
    );
    if (removeCurrentId.length === 0) {
      return <span>Select</span>;
    }

    const selectedTeachers = removeCurrentId.map((id) => {
      const teacher = allDistrictTeacher.find((item) => item.id === id);
      return teacher ? `${teacher.firstName} ${teacher.lastName}` : "";
    });

    // Display up to 1 selected items directly, others in a tooltip
    const displayedItems = selectedTeachers.slice(0, 1).map((name, index) => (
      <span key={index} className={classes.menuItemText}>
        {name}
      </span>
    ));

    const tooltipItems = selectedTeachers.slice(1).join(", ");

    return (
      <Tooltip title={tooltipItems} placement="top">
        <div>
          {displayedItems}
          {selectedTeachers.length > 1 && (
            <span className={classes.menuItemText}>...</span>
          )}
        </div>
      </Tooltip>
    );
  };
  const validationPrint = () =>{
    if (isMobile || isTablate) {
      showAlert("Print is not supported on this device!", "error");
      return;
  }
     else{
    addPrintableClass()
    printCall()
  }
  }
  const printCall = useReactToPrint({
    contentRef: imageRef,
    onBeforeGetContent: async () => { setPrintloader(true) },
    onBeforePrint: async () => {
      setPrintloader(false);
    },
    onAfterPrint: async ()=>{
      removePrintableClass()
    }
  });

  const truncatedText =
    standardText.length > maxChars
      ? `${standardText.substring(0, maxChars)}...`
      : standardText;
  const truncatedState =
    stateText.length > 11 ? `${stateText.substring(0, 11)}...` : stateText;

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);  // State to manage dropdown visibility
    const tagRender = (props) => {
      const { label, value, closable, onClose } = props;
    
      const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
      };
    
      const isInitiallySelected = initialValues.includes(value);
    
      const selectedCount = Array.isArray(value) ? value.length : 0;
    
      if (selectedCount > 1) {
        return (
          <Tag
            color={"blue"}
            onMouseDown={onPreventMouseDown}
            closable={!isInitiallySelected && closable}
            onClose={onClose}
            style={{ marginInlineEnd: 4 }}
          >
            more..
          </Tag>
        );
      }
    
      // Handling labelText (only show names)
      let labelText = '';
    
      // Check if label is an array of React elements
      if (Array.isArray(label)) {
        for (let i = 0; i < label.length; i++) {
          const children = label[i]?.props?.children;
          if (children && children !== false && children !== "Shared") { // Exclude "Shared"
            labelText = children;
            break;
          }
        }
      }
      // If label is a string, assign directly
      else if (typeof label === 'string') {
        labelText = label;
      }
      // If label is an object, extract text or name
      else if (typeof label === 'object' && label !== null) {
        labelText = label?.text || label?.name || label?.label || '';
      }
    
      if (!labelText) {
        labelText = 'No Label';
      }
    
      // Only append "..." if the label's length exceeds 15 characters
      const displayedLabel = labelText.length > 15 ? `${labelText.slice(0, 15)}...` : labelText;
    
      // Handle the click to toggle dropdown visibility
      const handleTagClick = (event) => {
        onPreventMouseDown(event);
        setIsDropdownOpen(!isDropdownOpen);  // Toggle dropdown visibility
      };
    
      return (
        <Tag
          color={"blue"}
          onClick={handleTagClick}  // Handle the click to open the dropdown
          closable={!isInitiallySelected && closable}
          onClose={onClose}
          className="selectTagVal"
        >
          {displayedLabel}
        </Tag>
      );
    };
    
    
  const getMaskIdFrom = get(
    find(get(data, "content"), (k) => k.pageId === superLessonData?.from),
    "numberMasked",
    superLessonData?.from
  );

  const getMaskIdTo = get(
    find(get(data, "content"), (k) => k.pageId === superLessonData?.to),
    "numberMasked",
    superLessonData?.to
  );
  const closeAlert = () => {
    setAlertSakeBar({ open: false, message: "", severity: "success" });
  };

  const { Option } = AntSelect;

  const handleVisibleChange = (visible) => {
    setIsDropdownOpenLanguage(visible);
  };

  const handleClickLanguage = useCallback((e) => {
    setLanguageChanger(e.key)
    if(e.key?.toLowerCase() === "english"){
      setContent(filterMyData?.english_content);
    }else{
      setContent(filterMyData?.lesson_content);
    }
  }, [filterMyData, superData])

   const menuNav = useMemo(() => {
     const items = [
       {
         key: 'english',
         label: 'English',
         className: 'contextCenter',
         style: {
          whiteSpace: 'nowrap',
          textTransform: 'uppercase',
         },
       },
       {
         key: `${superData?.language}`,
         label: `${superData?.language}`,
         className: 'contextCenter',
         style: {
           whiteSpace: 'nowrap',
           textTransform: 'uppercase',
         },
       },
     ];
     return {
       items: items,
       onClick: handleClickLanguage,
     };
   }, [superData,filterMyData]);
  


  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertSakeBar.open}
        autoHideDuration={3000}
        onClose={closeAlert}
      >
        <Alert
          onClose={() => {
            setAlertSakeBar({ open: false, message: '' });
          }}
          severity={alertSakeBar.severity}
        >
          <strong>ALERT:</strong> {alertSakeBar.message}
        </Alert>
      </Snackbar>
      {open && (
        <LessonContainer isCanvasUser={isCanvasUser}>
          <LessonModal
            style={{ position: 'relative' }}
            view={viewLessonType === 'shared' && showShareList ? true : false}
          >
            <span
              onClick={() => {
                if (viewLessonTypeValue) {
                  setAlertSakeBar({
                    open: true,
                    message: "Please wait for the lesson to be generated",
                    severity: "info",
                  });
                  return;
                }
                // setSelectedTeacherIds([]);
                setLoaderRetry(false);
                setShowShareList(true);
                setFilterSharedLesson(filterShareLesson);
                setFilterMyData(filterLesson);
                setGeneratedContent('')
                setIsDropdownOpenLanguage(false);
                setLanguageChanger("");
                onClose();
              }}
            >
              <Cancel
                className='lessonVwMdlClose'
                style={{
                  float: 'right',
                  fontSize: viewLessonType === 'shared' && showShareList ? 25 : 20,
                  color: 'red',
                  background: 'white',
                  borderRadius: 20,
                  cursor: 'pointer',
                  marginBottom: 5,
                  position: 'absolute',
                  right: '-10px',
                  top: '-10px',
                }}
              />
            </span>
            <div style={{ position: 'absolute', top: 10, left: 10, float: 'left', marginTop: '-5px', marginRight: '5px' }}>
              <AIUsageInfo />
            </div>
            {viewLessonType === 'shared' && showShareList ? (
              <div className="shared-lesson-container">
                <div className="shared-lesson">Shared Lesson</div>
                <div className="shared-lesson-title-container">
                  {map(filterSharedLesson, (item) => {
                    const findShareBy = allDistrictTeacher.find((obj) => item.userId === obj?.id);
                    if (!findShareBy) return null;
                    return (
                      <React.Fragment key={item?.id || item?.userId}>
                        <div
                          className="share-by-lesson"
                          onClick={() => {
                            setShowShareList(false);
                            setFilterMyData(item);
                          }}
                        >
                          <span className="title-for-share">
                            {`${from !== 'ebook' ? 'Super Lesson' : `Super Lesson (P. ${getMaskIdFrom}-${getMaskIdTo})`}`}{' '}
                            -
                          </span>
                          <span className="shared-by-text">&nbsp; shared by:</span>
                          <span className="shared-by-teacher-name">{` ${findShareBy?.firstName} ${findShareBy?.lastName}`}</span>
                        </div>
                        <div className="share-by-line-lesson" />
                      </React.Fragment>
                    );
                  })}
                </div>
                <div
                  className="share-by-Back-lesson"
                  onClick={() => {
                    handleBack();
                  }}
                >
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <AntdButton
                      className="back-button-super-lesson"
                      type="primary"
                      loading={loader}
                      style={{
                        borderRadius: 10,
                        minWidth: 179,
                        backgroundColor: '#017216',
                        border: '1px solid white',
                        minHeight: 55,
                        fontSize: 22,
                      }}
                    >
                      {'Back'}
                    </AntdButton>
                  </span>
                </div>
              </div>
            ) : (
              <>
                <Container>
                  <SuperLessonLogoImg
                    className={isCanvasUser ? 'isCanvasSuperLessonLogo' : ''}
                    src={SuperLessonLogo}
                  />
                  {viewLessonTypeValue ? (
                    <div className='cstmSkeleton'><Skeleton active paragraph={{ rows: 4 }} title={false} /></div>
                  ) : (
                    <div className={isCanvasUser ? 'canvasSuperLessonContainer' : ''}>
                      {filterMyData?.userId === currentUser?.id ? (
                        <BoxContainer
                          className={`shareWithUpr ${isCanvasUser ? 'canvasSuperLessonBoxContainer' : ''}`}
                          style={{
                            marginRight: 6,
                            marginLeft: 13,
                            marginBottom: 12,
                            marginTop: 0
                          }}
                        >
                          <div className="shareWithLft">
                            <Label>Share With:</Label>
                            <FieldShareBox
                              style={{
                                background: 'none',
                                flex: '1',
                                border: 'none',
                                placeItems: 'start',
                              }}
                            >
                              <Space
                                direction="vertical"
                                style={{ width: '100%', maxWidth: '100%' }}
                              >
                                <AntSelect
                                  dropdownStyle={{ minWidth: '250px' }}
                                  tagRender={tagRender}
                                  className="dropdown-select setValCstm"
                                  {...sharedProps}
                                  {...selectProps}
                                  menuItemSelectedIcon={null}
                                  maxTagCount={1}
                                >
                                  {getAllOptions.map((item) => {
                                    const cleanLabel = item.label.replace(/,\s*$/, '');

                                    return (<Option key={item.value} value={item.value} label={cleanLabel}>
                                      {initialValues.includes(item?.value) ? (
                                        <span className="shared-text-super-lesson">Shared</span>
                                      ) : (
                                        <>
                                          {value.some((data) => data.value === item?.value) && (
                                            <CheckOutlined className="checkmark-icon-super-lesson" />
                                          )}
                                        </>
                                      )}
                                      <Space>
                                        {cleanLabel.length > 19
                                          ? cleanLabel?.slice(0, 19) + '...'
                                          : cleanLabel}
                                      </Space>
                                    </Option>
                                    );
})}
                                </AntSelect>
                              </Space>
                            </FieldShareBox>
                          </div>

                          <div className="shareWithRght">
                            <div
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                // if (!AssignmentShareList?.includes(render?.id)) {
                                //   handleSend(render?.id)
                                // }
                                if (isDisable()) {
                                  handleShare();
                                }
                              }}
                            >
                              <span
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                }}
                                className="shareBtnCstm"
                              >
                                <AntdButton
                                  className="share-button-super-lesson"
                                  type="primary"
                                  loading={loader}
                                  disabled={!isDisable()}
                                  style={{
                                    borderRadius: 10,
                                    border: '0px',
                                    color: 'black',
                                    cursor: isDisable() ? 'pointer' : 'not-allowed',
                                    backgroundColor: isDisable() ? undefined : '#b3b3b3',
                                  }}
                                >
                                  Share
                                </AntdButton>
                              </span>
                            </div>
                            <div
                              style={{ cursor: 'pointer', width: '50px' }}
                              onClick={() => {
                                validationPrint();
                              }}
                            >
                              <span
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                }}
                              >
                                <AntdButton
                                  className="share-button-super-lesson"
                                  type="primary"
                                  style={{
                                    borderRadius: 10,
                                    border: '0px',
                                    color: 'black',
                                  }}
                                >
                                  {printLoader ? <Loading size={20} /> : <Print />}
                                </AntdButton>
                              </span>
                            </div>
                            <BoxContainer className="flex-1">
                              <SuperLessonEditor
                                initialMarkdown={generatedContent?.length > 0 ? generatedContent : content}
                                onSave={(value) => {
                                    setContent(value);
                                    setLanguageChanger(languageChanger)
                                }}
                                id={filterMyData?.id}
                                language={languageChanger || ""}
                              />
                            </BoxContainer>
                          </div>
                        </BoxContainer>
                      ) : (
                        <BoxContainer
                          style={{
                            marginRight: 6,
                            marginLeft: 13,
                            marginBottom: 22,
                          }}
                        >
                          <Label>Share By:</Label>
                          <FieldShareBox>
                            {`${filterByTeacher?.firstName} ${filterByTeacher?.lastName}`}
                          </FieldShareBox>
                          <div
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              handleShareDelete();
                            }}
                          >
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                              }}
                            >
                              <AntdButton
                                type="primary"
                                loading={loader}
                                style={{
                                  borderRadius: 10,
                                  minWidth: 108,
                                  backgroundColor: color.greentrue,
                                  border: '0px',
                                }}
                              >
                                {'Delete'}
                              </AntdButton>
                            </span>
                          </div>
                          <div
                            style={{ cursor: 'pointer', width: '50px' }}
                            onClick={() => {
                              validationPrint();
                            }}
                          >
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                              }}
                            >
                              <AntdButton
                                className="share-button-super-lesson"
                                type="primary"
                                style={{
                                  borderRadius: 10,
                                  border: '0px',
                                  color: 'black',
                                }}
                              >
                                {printLoader ? <Loading size={20} /> : <Print />}
                              </AntdButton>
                            </span>
                          </div>
                        </BoxContainer>
                      )}
                      <ViewContainer isCanvasUser={isCanvasUser}>
                        <BoxContainer style={{ marginRight: 6 }}>
                          <Label>Grade Level:</Label>
                          <FieldBox>{`${superData?.grade_level}`}th Grade</FieldBox>
                        </BoxContainer>
                        <BoxContainer style={{ marginRight: 9 }}>
                          <Label>State:</Label>
                          <FieldBoxState>
                            <Tooltip title={stateText.length > 11 ? stateText : null}>
                              <span style={{ whiteSpace: 'nowrap' }}>{truncatedState}</span>
                            </Tooltip>
                          </FieldBoxState>
                        </BoxContainer>
                        <BoxContainer>
                          <Label>Time Frame:</Label>
                          <FieldBox>{`${superData?.time_per_lesson}`}</FieldBox>
                        </BoxContainer>
                        <BoxContainer>
                          <Label>Days</Label>
                          <FieldBox>{`${superData?.days}`}</FieldBox>
                        </BoxContainer>
                        <BoxContainer className="flex-1">
                          <Label>Standard Selection:</Label>
                          <FieldBox className="flex-1 max-w-241px">
                            <Tooltip title={standardText.length > maxChars ? standardText : null}>
                              <span style={{ whiteSpace: 'nowrap' }}>{truncatedText}</span>
                            </Tooltip>
                          </FieldBox>
                        </BoxContainer>
                        <BoxContainer >
                          <Label>Language</Label>
                          {filterMyData?.hasOwnProperty('english_content') && filterMyData?.english_content ? (
                             <Dropdown
                              menu={menuNav}
                              placement="bottomLeft"
                              trigger={["click"]}
                              getPopupContainer={(trigger) => trigger.parentNode}
                              onOpenChange={handleVisibleChange}
                              open={isDropdownOpenLanguage}
                            >
                              <AssignmentPlan>
                                <AssignmentPlanInner>
                                  {languageChanger || superData?.language}
                                  <DownOutlined
                                    className={isDropdownOpenLanguage ? "rotate-icon" : ""}
                                    style={{
                                      transition: "transform 0.3s",
                                      transform: isDropdownOpenLanguage ? "rotate(180deg)" : "rotate(0deg)",
                                    }}
                                  />
                                </AssignmentPlanInner>
                              </AssignmentPlan>
                            </Dropdown>
                          ): (
                             <FieldBox>{`${superData?.language}`}</FieldBox>
                          )}
                          
                        </BoxContainer>
                      </ViewContainer>
                    </div>
                  )}
                </Container>
                <WhiteBox ref={imageRef} className="to_be_print">
                  {viewLessonTypeValue || content
                   ? (
                    // && content.trim()
                    <div
                      style={{ maxHeight: 'unset', padding: 0 }}
                      className="lesson-plan-container to_be_print lessonPlanUprCstm"
                      dangerouslySetInnerHTML={{
                        __html: converMarkToHtmlText(generatedContent?.length > 0 ? generatedContent : viewLessonTypeValue || content),
                      }}
                    />
                  ) : (
                    <NoMessageContainer>
                      <div style={{ width: '50%' }}>
                        <Suspense fallback={null}>
                          <Lottie animationData={ELEPHANT.poster} />
                        </Suspense>
                      </div>
                      <div
                        style={{
                          padding: '10px 20px 20px 20px',
                          textAlign: 'center',
                          color: '#ff4d4f',
                          fontWeight: 'bold',
                        }}
                      >
                        Uh-oh! Looks like the internet took a quick break. Give it another shot!
                      </div>
                      <RetryButton disabled={loaderRetry} onClick={() => onLessonAi()}>
                        {loaderRetry ? (
                          <Loading size={16} white />
                        ) : (
                          <span>
                            <RetweetOutlined style={{ marginRight: 5 }} /> Try again
                          </span>
                        )}
                      </RetryButton>
                    </NoMessageContainer>
                  )}
                </WhiteBox>
              </>
            )}
          </LessonModal>
        </LessonContainer>
      )}
    </>
  );
};

export default LessonViewModal;

const AssignmentPlan = styled.button`
    // background-image: linear-gradient(to right,${COLOR.indigo500}, ${COLOR.indigo600});
    background-color: #fff;
    // border: none;
    border-radius: 9.5px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 4px;

    @media only screen and (max-width: 1367px){
      margin-top:5px;
    }
}
`;

const AssignmentPlanInner = styled.div`
  display: flex;
  // flex-direction: column;
  flex-direction: row;
  gap: 5px;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  padding-left: 6px;
  padding-right: 6px;
  text-transform: uppercase;
  color: black;
`;
